export const text = {
  PAYMENT: 'Payment',
}
